// extracted by mini-css-extract-plugin
var _1 = "N2O5J";
export { _1 as "base" }
